import type { RailwayService } from '@cli-types/next-adapter/railway.js'
import { isNonEmptyString } from '@cli-utils/shared.js'

export function parseService(value: unknown): RailwayService | undefined {
  if (!value || typeof value !== 'object') return undefined
  const service = value as Record<string, unknown>
  if (!isNonEmptyString(service.id) || !isNonEmptyString(service.name)) return undefined
  const replicas =
    service.replicas && typeof service.replicas === 'object'
      ? (service.replicas as Record<string, unknown>)
      : undefined
  return {
    id: service.id,
    name: service.name,
    replicaCount: typeof replicas?.configured === 'number' ? replicas.configured : undefined
  }
}
